
import { ActionTypes } from "./types";

export function setScheduleTemplates(scheduleTemplates: ScheduleTemplate[]) {
  return {
    type: ActionTypes.SET_SCHEDULE_TEMPLATES,
    scheduleTemplates: scheduleTemplates
  }
}